/*==========================================================
TRIGGER RESIZE SCRIPT
==========================================================*/
//trigger resize event (cross browser compatible)
function triggerResizeEvent() {
    if (!$('#uber').hasClass('edit-mode'))
    {
        if (typeof (Event) === 'function') {
            // modern browsers
            window.dispatchEvent(new Event('resize'));

        } else {
            //This will be executed on old browsers and especially IE
            var resizeEvent = window.document.createEvent('UIEvents');
            resizeEvent.initUIEvent('resize', true, false, window, 0);
            window.dispatchEvent(resizeEvent);
        }
    }
}